import { Component, ViewChild, Input, Renderer2, ChangeDetectorRef, ElementRef } from '@angular/core';
import * as _ from 'lodash';
import { CommonFunctions } from '../static/common-functions';
import { GlobalsService } from '../services/globals.service';
import { LineItemsSummary } from '../models/LineItemsSummary';
import { MessageType } from '../enums/MessageType';
import { UntypedFormGroup } from '@angular/forms';
import { InventoryService } from '../services/inventory.service';
import { BaseService } from '../services/base.service';
import { CommonValues } from '../static/CommonValues';
import { GItem } from '../models/GItem';
import { BaseGridEditLineComponent } from './base-grid-editline.component';
import { TaxCodeBus } from '../models/TaxCodeBus';
import { CustomPricingBus } from '../models/CustomPricingBus';
import { QILineItemBus } from '../models/QILineItem';
import { BaseInvBus } from '../models/BaseInvBus';
import { CommonParam } from '../models/CommonParam';
import { InvoiceMessageInfo } from '../models/InvoiceMessageInfo';
import { DQOIService } from '../services/DQOI.service';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { QIParam } from '../models/QIParam';
import { KEY_NUM } from '../enums/KEY_NUM';
import { HotKeyRequest } from '../models/HotKeyRequest';
import { ContextMenuComponent } from '@progress/kendo-angular-menu';
import { InvoiceProfit } from '../models/InvoiceProfit';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { validateOverridables, EmptyOverridable } from '../decorators/overridable/base-method-override-decorator';

@Component({
    selector: '',
    template: ''
})
export class BaseGridEditInvLinesComponent<T extends QILineItemBus, D, S extends BaseService, P extends BaseInvBus> extends BaseGridEditLineComponent<T, D, S>  {

    constructor(protected globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_inv: InventoryService, svc_dqoi: DQOIService, featureFlagService: FeatureFlagService) {
        super(globals, renderer, cd, featureFlagService);

        this.svc_dqoi = svc_dqoi;
        validateOverridables(this, Object.getPrototypeOf(this).constructor.name, BaseGridEditInvLinesComponent);
    }
    @EmptyOverridable()
    costChange(event, dataItem, editForm) { }

    @EmptyOverridable()
    setRowFromCostAndPriceRange(vals: any, editForm: any, dataItem: any) { }

    @EmptyOverridable()
    setMarkupPercentFromMUCostChange(vals: any, editForm: any, dataItem: any) { }

    @EmptyOverridable()
    partQuantityChanged(qtyTo: number, qtyFrom: number) { }

    @EmptyOverridable()
    setInventoryLineDataCustom(info: InvoiceMessageInfo) { }

    @EmptyOverridable()
    invLocCBOChanged(e: any) { }

    get isInvoice(): boolean {
        return this.appCode === "InvoiceLines";
    }

    @ViewChild('CM_INVLINES') cm_InvLines: ContextMenuComponent;
    @ViewChild('target') cm_target: ElementRef;

    keyPressEvent(event: KeyboardEvent) {
        if (event.altKey === true) {
            if (event.keyCode === KEY_NUM.D) {
                this.hkAddInventoryLine(CommonValues.BillingCode_DTLAB);
            }
            else if (event.keyCode === KEY_NUM.F) {
                if (this.isConstruction) {
                    this.hkAddInventoryLine(CommonValues.BillingCode_CONSTO);
                }
                else {
                    this.hkAddInventoryLine(CommonValues.BillingCode_SFREIGHT);
                }
            }
            else if (event.keyCode === KEY_NUM.L) {
                this.hkAddInventoryLine(CommonValues.BillingCode_LAB);
            }
            else if (event.keyCode === KEY_NUM.M) {
                if (this.isConstruction) {
                    this.hkAddInventoryLine(CommonValues.BillingCode_CONSTM);
                }
                else {
                    this.hkAddInventoryLine(CommonValues.BillingCode_SMAT);
                }
            }
            else if (event.keyCode === KEY_NUM.O) {

                this.hkAddInventoryLine(CommonValues.BillingCode_OTLAB);
            }
            else if (event.keyCode === KEY_NUM.R) {
                if (this.isConstruction) {
                    //                    this.cm_InvLines.show(this.cm_target);
                    this.hkAddInventoryLine(CommonValues.BillingCode_RET);
                }
                else {
                }
            }
            this.globals.sendKeyPress(null);
        }

    }
    hkAddInventoryLine(invBCId: any) {
        this.dataLoading = true;
        this.openCpSearchOnAdd = false;
        this.addHandler();
        let param: CommonParam = new CommonParam();

        param.customerId = this.parentObj.customerId;
        param.locationId = this.parentObj.locationId;
        param.addParam("InventoryBillingCodeId", invBCId);
        param.addParam("AccountClassId", this.parentObj.accountClassId);
        param.addParam("PersonId", this.selectedData.personId);
        param.addParam("TaxCodeId", CommonFunctions.hasValue(this.taxCode) ? this.taxCode.taxCodeId : null);
        param.addParam("bcUsePricing", false);

        this.setInventoryLine(param);
    }
    getInventoryBC(param: HotKeyRequest) {
        this.svc_inv.getInventoryBC(param).subscribe((info: BaseMessageInfo) => {

            this.processingHotKey = false;
        });
    }
    taxCodeManuallyChangedOnce: boolean = false;
    manuallyChangeTaxCode(val: boolean) {
        this.taxCodeManuallyChangedOnce = val;
    }
    protected _taxCode: TaxCodeBus;
    _parentObj: P;
    _profit: InvoiceProfit;
    get profit(): InvoiceProfit {
        return this._profit;
    }
    get parentObj(): P {
        return this._parentObj;
    }
    createNewParent(data: P): any {
        return null;
    }
    svc_dqoi: DQOIService;
    @Input() parentLoading: boolean = false;
    public _taxTypeCode: number = 0;
    @Input() set parentObj(value: P) {
        this._parentObj = this.createNewParent(value);
    }
    @Input() set profit(value: InvoiceProfit) {
        this._profit = new InvoiceProfit(value);
    }
    @Input() set TaxCode(value: TaxCodeBus) {
        let setLines: boolean = false;
        if (value) {
            if (CommonFunctions.hasGuidValue(value.taxCodeId) && CommonFunctions.hasGuidValue(this.taxCode.taxCodeId) && value.taxCodeId != this.taxCode.taxCodeId && this.taxCodeManuallyChangedOnce) {
                setLines = true;
            }
        }
        this._taxCode = new TaxCodeBus(value);
        if (!this.parentLoading) {
            this.setTax(setLines, false);
            this.sumGrid();
        }
        else {
            this.sendParentMessage(MessageType.taxCodeLoaderOff, null, null, null);
        }
    }
    get hasValidTaxCode(): boolean {
        return CommonFunctions.hasGuidValue(this.taxCode.taxCodeId);
    }
    get canEditTax(): boolean {
        return true;
    }
    get hasParentObj(): boolean {
        return CommonFunctions.hasValue(this.parentObj);
    }
    get taxCode(): TaxCodeBus {
        return CommonFunctions.hasValue(this._taxCode) ? this._taxCode : new TaxCodeBus();
    }
    @Input() CustomPricing: CustomPricingBus;
    get hasCustomPricing(): boolean {
        return CommonFunctions.hasValue(this.CustomPricing);
    }
    get customPricing(): CustomPricingBus {
        return this.hasCustomPricing ? this.CustomPricing : new CustomPricingBus();
    }
    canSetTaxable(number: string): boolean {
        let canSet: boolean = this.rights.TaxableCheckbox;
        if (CommonFunctions.hasStringValue(number) && number.trim() === "RET") {
            canSet = false;
        }

        return canSet;
    }

    muChange(event, dataItem: T, editForm) {
        let mu = (event * 1) / 100;
        dataItem.price = dataItem.cost * (1 + mu);
        this.editForm.patchValue({
            price: dataItem.cost * (1 + mu),
            amount: dataItem.cost * (1 + mu) * (dataItem.quantity)
        });
    }

    protected getEditedGrid(): any[] {
        let gridData = _.cloneDeep(this.gridData);
        if (this.isEditing) {
            if (this.isNew) {
                gridData.push(this.editForm.value);
            } else {
                gridData[this.editedRowIndex] = this.editForm.value;
            }
        }

        return gridData;
    }
    public avalaraTaxAmount: number = 0;
    public sumGrid(dataItem: T = null) {
        if (!this.parentObj) {
            return;
        }
        let gridData = this.getEditedGrid();
        let labAmt: number = 0;
        let matAmt: number = 0;
        let othAmt: number = 0;
        let labCost: number = 0;
        let matCost: number = 0;
        let othCost: number = 0;
        let labCnt: number = 0;
        let labCostCnt: number = 0;
        let matCnt: number = 0;
        let othCnt: number = 0;
        let cost: number = 0;
        let amt: number = 0;
        let freightAmt: number = 0;
        let tax: number = 0;
        let tot: number = 0;
        let index: number = 0;
        let iiCountTemp = 0;
        gridData.forEach((e) => {
            if (e.billingTypeId != CommonValues.BillingType_Subtotal) {
                iiCountTemp++;
                cost += e.totalCost;
                amt += e.amount;
                tax += e.tax;
                if (e.billingTypeId == CommonValues.BillingType_Labor) {
                    labAmt += e.amount;
                    labCost += e.totalCost;
                    if (e.isPrintable) {
                        labCnt += e.quantity;
                    }
                    if (e.cost > 0) {
                        labCostCnt += e.quantity;
                    }
                }
                else if (e.isPart || e.billingTypeId == CommonValues.BillingType_NonInventoryPart) {
                    matAmt += e.amount;
                    matCost += e.totalCost;
                    if (e.isPrintable) {
                        matCnt += e.quantity;
                    }
                }
                else if (e.billingTypeId == CommonValues.BillingType_Other) {
                    othAmt += e.amount;
                    othCost += e.totalCost;
                    if (e.isPrintable) {
                        othCnt += e.quantity;
                    }
                }
                if (e.inventoryBillingCodeId == CommonValues.BillingCode_SFREIGHT) {
                    freightAmt += e.amount;
                }

            }
        });
        if (!CommonFunctions.hasValue(this.summary)) {
            this.summary = new LineItemsSummary();
        }
        this.setTax(false, false);
        this.summary.laborPrice = labAmt;
        this.summary.materialPrice = matAmt;
        this.summary.otherPrice = othAmt;
        this.summary.laborCost = labCost;
        this.summary.materialCost = matCost;
        this.summary.otherCost = othCost;
        this.summary.laborQty = labCnt;
        this.summary.laborCostedQty = labCostCnt;
        this.summary.materialQty = matCnt;
        this.summary.otherQty = othCnt;
        this.summary.totalCost = cost;
        this.summary.totalAmount = amt;
        // Feature-flagged Avalara/header tax total fix (ui-header-tax-calc).
        // Off = legacy: only isRetailTax includes tax on total.
        // On = shouldIncludeTaxInTotal() so Avalara sales tax is included even when isRetailTax was forced false.
        if (this.featureFlagService.latestFeatureFlagSet['ui-header-tax-calc']) {
            this.summary.total = this.shouldIncludeTaxInTotal()
                ? amt + CommonFunctions.getNumberValue(this.summary.totalTax)
                : amt;
        } else {
            this.summary.total = this.taxCode.isRetailTax ? amt + this.summary.totalTax : amt;
        }
        this.summary.freightAmt = freightAmt;
        //        this.summary.total = this.taxCode.isRetailTax ? amt + tax : amt;
        this.parentObj.costMaterial = this.summary.materialCost;
        this.parentObj.costLabor = this.summary.laborCost;
        this.parentObj.costOther = this.summary.otherCost;
        this.parentObj.cost = cost;
        //this.parentObj.taxAmount = tax;
        this.parentObj.saleMaterial = this.summary.materialPrice;
        this.parentObj.saleLabor = this.summary.laborPrice;
        this.parentObj.saleOther = this.summary.otherPrice;
        this.parentObj.amount = this.summary.totalAmount;
        this.parentObj.total = this.summary.total;

        this.sumAggregates(gridData);
    }

    dontCalcColumns: boolean;
    onBlur(event, dataItem: T, editForm: UntypedFormGroup, field: string) {
        if (!this.parentObj) {
            return;
        }
        let isAdded = !CommonFunctions.hasValue(dataItem.hasId);
        let callSetTax: boolean = false;
        if (editForm.get("changeCodeId") && !isAdded && this.hasFeatureFlag('ui-change-reason-code-feature-not-requiring-reason-for-updates-after-initial-save-of-reason') && !this.selectedData.isAdded) {
            if (editForm.get(field).value !== dataItem[field]) {

                editForm.patchValue({
                    changeCodeId: null
                });
            }
        }
        if (editForm.get(field).value !== dataItem[field] || isAdded || field == 'isTaxable' || (this.hasFeatureFlag("billing-code-reset-invline") && !isAdded && editForm.get("inventoryBillingCodeId").value !== dataItem["inventoryBillingCodeId"])) {
            var val = editForm.get(field).value;
            var vals = editForm.value;
            dataItem[field] = val;
            if (field == 'quantity') {
                let totalCost: number = vals.quantity * CommonFunctions.Round(vals.cost);
                totalCost = CommonFunctions.RoundToPrecision(totalCost, 2);
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * vals.price), 2);
                if (!this.taxCode.isRetailTax && vals.isTaxable) {
                    let tax: number = 0;
                    let taxRate: number = this.taxCode.taxRate;
                    tax = CommonFunctions.Round(totalCost * taxRate);
                    editForm.patchValue({
                        tax: tax
                    });
                    dataItem.tax = tax;
                }

                editForm.patchValue({
                    amount: amt
                    , totalCost: totalCost
                });
                dataItem.amount = amt;
                dataItem.totalCost = totalCost;
                callSetTax = true;
                if (vals.isPart && !dataItem.isConsumable && !dataItem.isTool) {
                    this.partQuantityChanged(vals.quantity, vals.originalQuantity);
                }
            }
            else if (field == 'cost') {
                let cost: number = CommonFunctions.RoundToPrecision(vals.cost, 3);
                let totalCost: number = CommonFunctions.RoundToPrecision((vals.quantity * cost), 2);
                if (!this.taxCode.isRetailTax && vals.isTaxable) {
                    let tax: number = CommonFunctions.Round(totalCost * this.taxCode.taxRate);
                    editForm.patchValue({
                        tax: tax
                    });
                    dataItem.tax = tax;
                    if (!vals.isPart) {
                        let muCost: number = CommonFunctions.Round(cost + (cost * this.taxCode.taxRate));
                        editForm.patchValue({
                            markupCost: muCost
                        });
                        dataItem.markupCost = muCost;
                    }
                }

                editForm.patchValue({
                    cost: cost,
                    totalCost: totalCost,
                });
                dataItem.cost = cost;
                dataItem.totalCost = totalCost;
                callSetTax = true;

                if (vals.inventoryBillingCodeId == CommonValues.BillingCode_MMAT) {
                    this.setRowFromCostAndPriceRange(vals, editForm, dataItem);
                }

            }
            else if (field == "markupCost") {
                if (vals.inventoryBillingCodeId == CommonValues.BillingCode_MMAT) {
                    this.setMarkupPercentFromMUCostChange(vals.markupCost, editForm, dataItem);
                } else {
                    if (!vals.isPart && !vals.isNonInvPart) {
                        let markup: number = vals.markupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                        editForm.patchValue({
                            markup: markup
                            , markupPercent: markup * 100
                        });
                        dataItem.markup = markup;
                    }
                    else {
                        if (CommonFunctions.hasArrayElementValue(this.customPricing.pricingRanges)) {
                            let markup: number = CommonFunctions.CalculateMarkup(vals.cost, this.customPricing.pricingRanges);
                            markup = CommonFunctions.RoundToPrecision(markup, 4);
                            let price: number = vals.markupCost * (markup + 1);
                            price = CommonFunctions.RoundToPrecision(price, 2);
                            let amount: number = CommonFunctions.RoundToPrecision(vals.quantity * price, 2);
                            editForm.patchValue({
                                markup: markup
                                , markupPercent: markup * 100
                                , price: price
                                , amount: amount
                            });
                            dataItem.markup = markup;
                            dataItem.price = price;
                            dataItem.amount = amount;
                        }
                    }
                }
            }
            else if (field == "markupPercent") {
                vals.markup = vals.markupPercent / 100;
                let calcMarkUp = CommonFunctions.RoundToPrecision(vals.markup, 4);
                let price: number = CommonFunctions.RoundToPrecision((vals.markupCost * (vals.markup + 1)), 2);
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * price), 2);
                editForm.patchValue({
                    price: price
                    , amount: amt
                });
                dataItem.price = price;
                dataItem.amount = amt;
                editForm.patchValue({
                    markup: calcMarkUp
                });
            }
            else if (field == "price") {
                let amt: number = CommonFunctions.RoundToPrecision((vals.quantity * vals.price), 2);
                let markup: number = vals.markupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                markup = CommonFunctions.RoundToPrecision(markup, 4);
                editForm.patchValue({
                    amount: amt
                    , markupPercent: markup * 100
                    , markup: markup
                });
                dataItem.amount = amt;
                dataItem.markup = markup;
                if (vals.price == 0) {
                    editForm.patchValue({
                        isPrintable: false
                    });
                }
            }
            else if (field == "amount") {
                let price: number = vals.quantity != 0 ? vals.amount / vals.quantity : 0;
                price = CommonFunctions.RoundToPrecision(price, 2);
                let markup: number = vals.macrkupCost != 0 ? vals.price / vals.markupCost - 1 : 0;
                markup = CommonFunctions.RoundToPrecision(markup, 4);
                editForm.patchValue({
                    price: price
                    , markup: markup
                });
                dataItem.price = price;
                dataItem.markup = markup;
            }
            if (!isAdded) {
                dataItem.calculateTotals();
            }
            let paramDataItem: T = isAdded ? dataItem : null;
            paramDataItem = dataItem;
            this.sumGrid(paramDataItem); //dataItem.hasId ? null : dataItem);
        }
    }
    override setInventorySearchData(value: any) {
        let param: CommonParam = new CommonParam();

        param.customerId = this.parentObj.customerId;
        param.locationId = this.parentObj.locationId;
        param.addParam("InventoryBillingCodeId", value.InventoryId);
        param.addParam("AccountClassId", this.parentObj.accountClassId);
        param.addParam("PersonId", this.selectedData.personId);
        param.addParam("TaxCodeId", CommonFunctions.hasValue(this.taxCode) ? this.taxCode.taxCodeId : null);
        param.addParam("bcUsePricing", false);

        this.setInventoryLine(param);
    }
    protected afterSetInventoryLine() {
        if (this.processingHotKey) {
            this.processingHotKey = false;

        }
        this.openCpSearchOnAdd = true;
    }
    setInventoryLineTest(param: CommonParam) {
        this.svc_dqoi.getItemSelected(param).subscribe((info: BaseMessageInfo) => {
        });
    }

    setInventoryLine(param: CommonParam) {
        this.inventorySearching = true;
        this.svc_dqoi.getInventoryLine(param).subscribe(
            {
                next:
                    (info: InvoiceMessageInfo) => {
                        this.selectedData.setInventoryLine(info.primaryReturn, this.selectedData.hasId);
                        if (info.getEmpRate === true && this.hasEditForm) {
                            this.selectedData.fullDescription = this.editForm.value.fullDescription;
                            this.selectedData.isTaxable = this.editForm.value.isTaxable;
                            this.selectedData.quantity = this.editForm.value.quantity;
                            this.setInventoryLineDataCustom(info);
                        }
                        this.afterSetInventoryLine();
                        this.selectedData.resource = this.personName(this.selectedData.personId);
                        this.selectedData.calculateTotals();
                        if (!this.editForm) {
                            this.createForm();
                        }
                        this.setForm();
                        this.afterSetInventoryLineAfterSetForm();
                        this.inventorySearching = false;
                        this.sumGrid(this.selectedData);
                        this.setDirty();
                        this.dataLoading = false;
                    },
                error: (error) => {
                    this.inventorySearching = false;
                    console.error(error);
                    this.globals.notifyError(`Error getting inventory line. ${CommonValues.ErrorMessages_BaseErrorSuffix}`, true);
                }
            });
    }
    setTaxLine(dataItem: T = null): number {
        let tax: number = 0;
        if (!this.taxCode.isRetailTax) {
            let taxRate = this.taxCode.taxRate;
            if (!this.taxCode.hasTax) {
                dataItem.isTaxable = false;
            }
            if (dataItem.isTaxable) {
                tax = CommonFunctions.Round(dataItem.cost * taxRate);
                dataItem.markupCost += tax;
                dataItem.tax = CommonFunctions.Round(dataItem.totalCost * taxRate);
            }
            else {
                dataItem.markupCost -= tax;
                dataItem.tax = 0;
            }
            this.selectedData.tax = tax;
            this.selectedData.markupCost = dataItem.markupCost;
            this.editForm.patchValue({
                tax: tax
                , markupCost: dataItem.markupCost
            });
        }
        return tax;
    }

    setTax(setLines: boolean = false, setTaxLine: boolean = false) {
        let editLineTax: number = 0;
        if (setTaxLine && this.hasEditForm) {
            //[GRG20210511]     editLineTax = this.setTaxLine(this.editForm.value);
            editLineTax = this.setTaxLine(this.editForm.value);
        }

        let taxAmount: number;

        if (this.taxCode.isAvalara) {
            taxAmount = this.avalaraTaxAmount;
        }
        else {
            taxAmount = this.calculateTax(setLines);
        }
        if (this.summary) {
            this.summary.totalTax = taxAmount;
        }
        if (this.hasParentObj) {
            this.parentObj.taxAmount = taxAmount; // + editLineTax;
        }
    }
    public get taxTypeCode(): number {
        return this.hasParentObj ? this.parentObj.taxTypeCode : 0;
    }
    public get isRetailTax(): boolean {
        return this.taxTypeCode == 1 ? true : false;
    }
    public calculateTax(setLines: boolean = false): number {

        let gridData: T[] = this.getEditedGrid();
        if (setLines) {
            gridData = this.gridData;
        }
        let totalTaxAmount: number = 0;
        if (CommonFunctions.hasArrayElementValue(gridData)) {
            for (let i = 0; i < gridData.length; i++) {
                let line: T = gridData[i]; //null;
                let lineTax: number = 0;
                let isTaxable: boolean = false;
                if (setLines) {
                    line.isUpdated = true;
                }
                if (!this.taxCode.hasTax || line.inventoryBillingCodeId === CommonValues.BillingCode_RET) {
                    line.isTaxable = false;
                }
                else {
                    isTaxable = this.taxCode.IsTaxable(line.billingTypeId, line.isPart);
                    if (setLines) {
                        line.isTaxable = isTaxable;
                    }
                    else if (!line.isTaxable) {
                        isTaxable = false;
                    }
                }

                if (isTaxable == true) {
                    lineTax = this.calculateTaxOnLine(line);
                }
                totalTaxAmount += lineTax;

                if (!this.isRetailTax) {
                    line.tax = CommonFunctions.Round(lineTax);
                }
                else {
                    line.tax = 0;
                }
            }

        }
        let retTaxAmount = CommonFunctions.Round(totalTaxAmount);
        return retTaxAmount;
    }
    protected calculateTaxOnLine(line: T) {
        let taxAmount: number = 0;
        if (line.isTaxable && this.taxCode.taxLines) {
            for (let tl = 0; tl < this.taxCode.taxLines.length; tl++) {
                let taxLine = this.taxCode.taxLines[tl];
                if (line.isPart || line.billingTypeId == CommonValues.BillingType_NonInventoryPart) {
                    if (taxLine.isTaxMaterial) {
                        if (this.taxCode.isRetailTax)
                            taxAmount += line.amount * taxLine.rate;
                        else
                            taxAmount += line.totalCost * taxLine.rate;
                    }
                }
                else if (!line.isPart && line.billingTypeId == CommonValues.BillingType_Labor) {
                    if (taxLine.isTaxLabor) {
                        if (this.taxCode.isRetailTax)
                            taxAmount += line.amount * taxLine.rate;
                        else
                            taxAmount += line.totalCost * taxLine.rate;
                    }
                }
                else if (line.billingTypeId == CommonValues.BillingType_Other) {
                    if (taxLine.isTaxOther) {
                        if (this.taxCode.isRetailTax)
                            taxAmount += line.amount * taxLine.rate;
                        else
                            taxAmount += line.totalCost * taxLine.rate;
                        //                                line.isTaxable = true;
                    }
                }
            }
        }
        return taxAmount;
    }

    personCBOChanged(e: GItem, editForm) {
        let param: CommonParam = new CommonParam();
        if (editForm.get("changeCodeId") && this.hasFeatureFlag('ui-change-reason-code-feature-not-requiring-reason-for-updates-after-initial-save-of-reason') && !this.selectedData.isAdded) {
            if (e.value !== this.selectedData["personId"]) {

                editForm.patchValue({
                    changeCodeId: null
                });
            }
        }
        param.customerId = this.parentObj.customerId;
        param.locationId = this.parentObj.locationId;
        param.addParam("InventoryBillingCodeId", editForm.value.inventoryBillingCodeId);
        param.addParam("AccountClassId", this.parentObj.accountClassId);
        param.addParam("PersonId", e.value);
        param.addParam("bcUsePricing", false);
        param.addParam("GetEmpRate", true);
        param.addParam("Price", editForm.value.price);
        this.selectedData.personId = e.value;
        this.setInventoryLine(param);
    }
    afterDelete() {
        this.reOrder();
        this.setTax();
        this.sumGrid();
    }

    processGridData() {
        this.sumGrid();
        this.AfterLoad();
    }
    public cancelHandler(): void {
        super.cancelHandler();
        this.sumGrid();
    }
    AfterLoad(): void { }

    /**
     * Whether customer-facing total should include taxAmount.
     * Used only when feature flag ui-header-tax-calc is enabled.
     * - Retail/sales tax: yes (amount + tax)
     * - Use tax (taxTypeCode == 2): no (tax is cost-side)
     * - Avalara: use taxTypeCode / isRetailTax; do not trust taxCode.isRetailTax alone
     *   because getAvalaraTaxRate forces isRetailTax=false for rate display.
     */
    protected shouldIncludeTaxInTotal(): boolean {
        if (this.taxTypeCode === 2) {
            return false;
        }
        if (this.taxCode?.isAvalara) {
            // Avalara sales tax is additive on total unless this is explicitly use tax.
            return true;
        }
        return !!(this.taxCode?.isRetailTax || this.isRetailTax);
    }

    public getCurrentTotals(): P {
        this.sumGrid();
        let parObj: P = _.cloneDeep(this.parentObj);
        // Feature-flagged Avalara taxAmount preserve (ui-header-tax-calc).
        // Off = legacy always recalculate via calculateTax.
        // On = keep Avalara taxAmount from sumGrid/setTax; calculateTax ignores Avalara.
        if (this.featureFlagService.latestFeatureFlagSet['ui-header-tax-calc']) {
            if (!this.taxCode?.isAvalara) {
                parObj.taxAmount = this.calculateTax(false);
            }
        } else {
            parObj.taxAmount = this.calculateTax(false);
        }
        return parObj;
    }
    protected getPartPrice(): Promise<BaseMessageInfo> {
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            let param: CommonParam = new CommonParam();
            param.customerId = this.parentObj.customerId;
            param.locationId = this.parentObj.locationId;
            param.addParam("inventoryId", this.editForm.value.inventoryBillingCodeId);
            param.addParam("quantity", this.editForm.value.quantity);
            param.addParam("markupCost", this.editForm.value.markupCost);
            this.svc_dqoi.getSetPartPrice(param).subscribe((info: BaseMessageInfo) => {
                retInfo = info;
                resolve(info);
            });
        });
    }
    recalculateAfterTaxCode() {
        if (!this.hasGridData) {
            return;
        }
        let param: QIParam = new QIParam();

        param.customerId = this.parentObj.customerId;
        param.locationId = this.parentObj.locationId;
        param.addParam("InventoryBillingCodeId", null);
        param.addParam("PersonId", null);
        param.addParam("Quantity", 0);
        param.addParam("AccountClassId", this.parentObj.accountClassId);
        param.addParam("TaxCodeId", CommonFunctions.hasValue(this.taxCode) ? this.taxCode.taxCodeId : null);
        param.addParam("bcUsePricing", false);
        let lineItems: QILineItemBus[] = this.getAll();
        var arr: QILineItemBus[] = [];
        for (let i = 0; i < lineItems.length; i++) {
            let item: QILineItemBus = new QILineItemBus(lineItems[i]);
            arr.push(item);
        }
        param.lineItems = arr;
        param.addParam("LineItems", arr);
        param.addParam("LineItems2", lineItems);

        this.svc_dqoi.recalculateAfterTaxCode(param).subscribe((info: BaseMessageInfo) => {

        });
    }
    isTaxableChanged(event, dataItem: T, editForm: UntypedFormGroup, field: string) {
        if (!this.parentObj) {
            return;
        }
        if (!this.taxCode.isRetailTax) {
            var val = editForm.get(field).value;
            var vals = editForm.value;
            dataItem[field] = val;
            let cost: number = CommonFunctions.RoundToPrecision(vals.cost, 3);
            let totalCost: number = CommonFunctions.RoundToPrecision((vals.quantity * cost), 2);
            let muCost: number = 0;
            let totalTax: number = 0;
            let lineTax: number = CommonFunctions.Round(cost * this.taxCode.taxRate);
            if (vals.isTaxable) {
                muCost = vals.markupCost + lineTax;
                totalTax = CommonFunctions.Round(totalCost * this.taxCode.taxRate);
            }
            else {
                muCost = vals.markupCost - lineTax;
            }
            editForm.patchValue({
                tax: totalTax,
                markupCost: muCost,
                markup: 0,
                markupPercent: 0
            });
            dataItem.markupCost = muCost;
            dataItem.tax = totalTax;
            dataItem.markup = 0;
            dataItem.markupPercent = 0;

            this.getPartPrice().then((info: BaseMessageInfo) => {

                if (!info.saveError && info.dcValues.valuesSet === true) {
                    let retLine: T = info.primaryReturn as T;
                    editForm.patchValue({
                        markup: retLine.markup,
                        price: retLine.price,
                        amount: retLine.amount
                    });
                    dataItem.markup = retLine.markup;
                    dataItem.price = retLine.price;
                    dataItem.amount = retLine.amount;
                    this.onBlur(event, dataItem, editForm, "isTaxable");
                }
            });
        }
        else {
            this.onBlur(event, dataItem, editForm, "isTaxable");
        }
    }
    customCheckBoxChanged(e: any, dataItem, rowIndex, column, columnIndex) {
        if (column.field === "isTaxable") {
            this.editForm.patchValue({
                isTaxable: e.target.checked
            });
            this.markControlDirty("isTaxable");
            this.isTaxableChanged(e, dataItem, this.editForm, column.field);

        }
        if (column.field === "isPrintable") {
            this.editForm.patchValue({
                isPrintable: e.target.checked
            });
            this.markControlDirty("isPrintable");
            this.sumGrid();

        }
    }

    afterSetInventoryLineAfterSetForm() {
        if (this.selectedData.inventoryBillingCodeId === CommonValues.BillingCode_SubTotal) {
            this.sub_calculate();
        }
    }
    sub_calculate() {
        let gridData = this.getEditedGrid(); //.filter(s => s.sortOrder <= this.selectedData.sortOrder);
        gridData.sort((a, b) => (a.sortOrder > b.sortOrder) ? 1 : -1);
        var priceSum = 0;
        var totalSum = 0;
        var costSum = 0;
        var totalCostSum = 0;
        for (let e of gridData) {
            if (e.inventoryBillingCodeId == CommonValues.BillingCode_SubTotal) {
                if ((priceSum != e.price) || (totalSum != e.amount)) {
                    //let gRow = this.gridData.find(s => s.sortOrder === e.sortOrder);
                    let gRow = this.gridData.find(s => s.CID() === e.CID);
                    if (gRow) {
                        gRow.price = priceSum;
                        gRow.amount = totalSum;
                        gRow.cost = costSum;
                        gRow.totalCost = totalCostSum;
                    }
                    else {
                        this.editForm.patchValue({
                            price: priceSum,
                            amount: totalSum,
                            cost: costSum,
                            totalCost: totalCostSum
                        });

                    }
                }
                priceSum = 0;
                totalSum = 0;
                costSum = 0;
                totalCostSum = 0;
            }
            else {
                priceSum = priceSum + e.price;
                totalSum = totalSum + e.amount;
                costSum = costSum + e.cost;
                totalCostSum = totalCostSum + e.totalCost;
            }
        };
    }
    dragDivClick(e: any) {
        if (this.isEditing && this.canSaveForm) {
            this.saveCurrent();
        }
    }
    getFreightPct(): number {
        let freightAmt: number = this.summary.freightAmt;
        let matCost: number = this.summary.materialCost;
        let pct: number = matCost > 0 ? (freightAmt / matCost) * 100 : 0;
        return pct;
    }
    hasProperFreight(locState: string): boolean {
        let isOk: boolean = true;
        if (this.summary.materialCost > 0) {
            let costMaterial: number = this.summary.materialCost;
            let freightPct: number = this.getFreightPct();
            if (locState == "HI") {
                if (freightPct < 30)
                    isOk = false;
            }
            else if (costMaterial > 0 && costMaterial <= 200) {
                if (freightPct < 30)
                    isOk = false;
            }
            else if (costMaterial > 200 && costMaterial <= 500) {
                if (freightPct < 25)
                    isOk = false;
            }
            else if (costMaterial > 500) {
                if (freightPct < 20)
                    isOk = false;
            }
        }
        return isOk;
    }
}

